<template>
    <div class="flex">
        <ButtonCircle :disabled="zoom <= ZOOM_MIN" @click="zoomDecrease" title="Zoom out">
            <i class="icon-zoom-out"></i>
        </ButtonCircle>
        <ButtonCircle :disabled="zoom >= ZOOM_MAX" @click="zoomIncrease" title="Zoom in">
            <i class="icon-zoom-in"></i>
        </ButtonCircle>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";

    export default {
        name: "ZoomControls",
        components: {ButtonCircle},
        computed: {
            ...mapState('editor', [
                'ZOOM_MIN',
                'ZOOM_MAX',
                'zoom',
                'zoomStep'
            ]),

        },

        methods: {
            ...mapActions('editor', [
                'setZoom',
            ]),

            zoomIncrease() {
                let zoom = this.zoom + this.zoomStep;

                this.setZoom(zoom);
            },

            zoomDecrease() {
                let zoom = this.zoom - this.zoomStep;

                this.setZoom(zoom);
            },

        },

    }
</script>

<style scoped>
    button {
        margin: 0 5px;
    }
</style>